import { useEffect, useState } from "react";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import useEventService from "../../../app/services/hooks/useEventService";
import SundaysData from "./SundaysData";
import HolidaysData from "./HolidaysData";
import { formatMoney } from "../../../utils/utils";
import SundaysDataTable from "./tables/SundaysDataTable";
import HolidaysDataTable from "./tables/HolidaysDataTable";


interface Props {
    travelEspensesFilter: any,
    setTravelEspensesFilter: (travelEspensesFilter: any) => void,
    searchAction: boolean
}

const SunadysAndHolidaysContainer = ({ 
    travelEspensesFilter,
    setTravelEspensesFilter,
    searchAction
}: Props) => {

    const { getTravelExpensesByEvents, fetchingGetTravelExpensesByEvents } = useEventService();
    const { getHolidaysEventsByDates, fetchingGetHolidaysEvents } = useEventService();


    const [sundaysNumber, setSundaysNumber] = useState(0);
    const [eventDays, setEventDays] = useState<any[]>([]);
    const [holidays, setHolidays] = useState<any[]>([]);
    const [sundays, setSundays] = useState<any[]>([]);
    const [sundaysTotal, setSundaysTotal] = useState(0);
    const [holidaysTotal, setHolidaysTotal] = useState(0);
    const [ufValue, setUfValue] = useState(0);

    const [sundaysDataTable, setSundaysDataTable] = useState<boolean>(false);
    const [holidaysDataTable, setHolidaysDataTable] = useState<boolean>(false);
    const [holidaysFilter, setHolidaysFilter] = useState<any>({
        first_day: travelEspensesFilter.first_day,
        last_day: travelEspensesFilter.last_day,
        worker_id: travelEspensesFilter.worker_id,
        page: 1,
        per_page: 10,
    });


    useEffect(()=>{
        if(travelEspensesFilter.worker_id){
            getTravelExpensesByEvents(travelEspensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setEventDays(response.data.events_number);
                    setSundaysNumber(response.data.sundays_number);
                    setSundays(response.data.sundays);
                    setSundaysTotal(response.data.total_sundays_budget);
                    setHolidays(response.data.holidays);
                    setHolidaysTotal(response.data.total_holidays_budget);
                    setUfValue(response.data.uf_value);

                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }

    },[searchAction]);


    const showSundays = () => {
        setSundaysDataTable(!sundaysDataTable)
    };

    const showHolidays = () => {
        setHolidaysDataTable(!holidaysDataTable)
    };



    return (
       <>
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showSundays}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium" style={{ userSelect: 'none' }}>{sundaysNumber} Domingos</p>
                                {fetchingGetTravelExpensesByEvents ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(sundaysTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {sundaysDataTable &&                
                    <div className="col-lg-10 mb-4">
                        <div className="h5">Domingos</div>
                        <SundaysDataTable 
                            data={sundays} 
                            totalRows={sundays.length} 
                            filter={travelEspensesFilter} 
                            setFilter={setTravelEspensesFilter}
                            ufValue={ufValue}
                        />
                    </div>
                }  

                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showHolidays}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium" style={{ userSelect: 'none' }}>{holidays.length} Feriado{holidays.length > 1 ? 's' : ''}</p>
                                {fetchingGetHolidaysEvents ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(holidaysTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {holidaysDataTable &&                
                    <div className="col-lg-10 mb-4">
                        <div className="h5">Feriados</div>
                        <HolidaysDataTable
                            data={holidays} 
                            totalRows={holidays.length} 
                            filter={travelEspensesFilter} 
                            setFilter={setTravelEspensesFilter}
                            ufValue={ufValue}
                        />
                    </div>
                }  

            
        </>

    )

}

export default SunadysAndHolidaysContainer;


